import { render, staticRenderFns } from "./uam-user-input.vue?vue&type=template&id=cf3f97e2"
import script from "./uam-user-input.vue?vue&type=script&lang=ts"
export * from "./uam-user-input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf3f97e2')) {
      api.createRecord('cf3f97e2', component.options)
    } else {
      api.reload('cf3f97e2', component.options)
    }
    module.hot.accept("./uam-user-input.vue?vue&type=template&id=cf3f97e2", function () {
      api.rerender('cf3f97e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitor-details/comments/uam-user-input.vue"
export default component.exports